import request from '../request'

// 根据菜单UUID查询菜单详情（包含关联的角色和用户）
// GET /user-service/menuPermission/detail/{menuUuid}
export function fetchDetail(menuUuid) {
    return request({
        url: `/user-service/menuPermission/detail/${menuUuid}`,
        method: 'GET',
    })
}

// 更新菜单关联的角色列表（传完整角色 uuid 数组替换）
// POST /user-service/menuPermission/updateRoles/{menuUuid}
// roleUuids: 角色uuid数组，如 ['uuid1', 'uuid2']
// 若后端要求对象格式（如 { roleUuids: [] }），把下面 data 改成 { roleUuids } 即可
export function updateRoles(menuUuid, roleUuids) {
    return request({
        url: `/user-service/menuPermission/updateRoles/${menuUuid}`,
        method: 'POST',
        data: roleUuids,
    })
}
